"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabViewController = void 0;
const core_1 = require("@veeam/core");
class TabViewController extends core_1.StatelessReactViewController {
    constructor(config) {
        super();
        this.config = config;
    }
    createElement() {
        return this.config.title;
    }
}
exports.TabViewController = TabViewController;
//# sourceMappingURL=TabViewController.js.map